// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"AccountManagementRecordLoader_placeholder__25KQ6"};